import { createFileRoute } from "@tanstack/react-router";
import { Container, Section } from "@alight/ui";
import { DesignPage } from "@alight/brand/board";
import themeCss from "../styles/theme.css?raw";
import { DesignGuide } from "../components/DesignGuide";
import { useSeo } from "../lib/seo";

export const Route = createFileRoute("/design")({
  component: DesignRoute,
});

/**
 * /design — the BRAND BOARD (shared: packages/brand/src/board) and, on its
 * second tab, this site's component style guide.
 *
 * DEV-ONLY: an internal tool for whoever is shaping the site's look. In a
 * production build `import.meta.env.DEV` is a literal `false`, the route
 * renders a plain "page not found", and the bundler drops the board and the
 * guide from the shipped JavaScript. noindex either way (docs/SEO.md).
 */
function DesignRoute() {
  if (!import.meta.env.DEV) return <NotFoundish />;
  return <DesignRoutePage />;
}

function DesignRoutePage() {
  useSeo({
    title: "Design | Connect Sydney",
    description: "Internal brand board and component guide for the Connect Sydney theme.",
    noindex: true,
  });
  return <DesignPage siteName="Connect Sydney" themeCss={themeCss} guide={<DesignGuide />} />;
}

/** What a visitor sees in production. Mirrors the router's own 404 copy. */
function NotFoundish() {
  useSeo({ title: "Page not found | Connect Sydney", noindex: true });
  return (
    <Section spacing="lg">
      <Container width="narrow" className="text-center">
        <h1 className="font-heading text-3xl font-extrabold text-ink">Page not found</h1>
        <p className="mt-4 text-lg text-muted">Sorry, we couldn&apos;t find that page.</p>
      </Container>
    </Section>
  );
}
